// @ts-nocheck

export type TicketGetWithTenant = typeof TicketGetWithTenant[keyof typeof TicketGetWithTenant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTenant = {
  true: 'true',
  false: 'false',
} as const;
